import api from './api';

/**
 * Independent Project Dashboard API — does not call Auth/SetProject or ProjectContext.
 */
const projectDashboardService = {
  async getProjects() {
    const response = await api.get('/ProjectDashboard/projects');
    return response.data;
  },

  async getKPIs(projectIdOrCode) {
    const params = {};
    if (projectIdOrCode != null && projectIdOrCode !== '') {
      const v = String(projectIdOrCode).trim();
      params[Number.isInteger(Number(v)) && v === String(Number(v)) ? 'projectId' : 'projectCode'] = v;
    }
    const response = await api.get('/ProjectDashboard/kpis', { params });
    return response.data;
  },

  async getStageCards(projectIdOrCode) {
    const params = {};
    if (projectIdOrCode != null && projectIdOrCode !== '') {
      const v = String(projectIdOrCode).trim();
      params[Number.isInteger(Number(v)) && v === String(Number(v)) ? 'projectId' : 'projectCode'] = v;
    }
    const response = await api.get('/ProjectDashboard/stage-cards', { params });
    return response.data;
  },
};

export default projectDashboardService;
